// Airports the landing pages can pre-fill: /book?service=point&from=jfk (arriving) or &to=jfk (flying out).
// The address is looked up like a typed one (geocode + zone detect), so the flat rate applies.
export const AIRPORTS = {
  jfk: { name: 'JFK', address: 'John F. Kennedy International Airport (JFK), Queens, NY 11430' },
  lga: { name: 'LaGuardia', address: 'LaGuardia Airport (LGA), Queens, NY 11371' },
  ewr: { name: 'Newark', address: 'Newark Liberty International Airport (EWR), Newark, NJ 07114' },
};

export const airportFor = (code) => AIRPORTS[(code || '').toLowerCase()] || null;

export const bookFromAirport = (code) => `/book?service=point&from=${code}`;
export const bookToAirport = (code) => `/book?service=point&to=${code}`;
